import { ReactElement, Fragment } from "react";
import { Link } from "react-router-dom";
import { Spinner } from "@justworkshr/milo-core";
import { Label } from "@justworkshr/milo-form";

import {
  PATH_TO_CHANGE_PASSWORD,
  PATH_TO_EDIT_PROFILE,
  PATH_TO_MFA,
} from "constants/navigation";

import { title as factorsLabel } from "../mfa/constants/mfaCopy";

import { FactorKey } from "types/factor/factor";
import { FieldName, FIELD_ORDER } from "./types/accountFields";

import ActiveFactors from "./components/activeFactors/ActiveFactors";

import styles from "./account-summary.module.css";

type AccountSummaryProps = {
  username: string;
  email: string;
  activeFactors?: FactorKey[];
  showLinks?: boolean;
};

const AccountSummary = ({
  username,
  email,
  activeFactors,
  showLinks = true,
}: AccountSummaryProps): ReactElement => {
  const fieldMap: Record<
    FieldName,
    {
      label: string;
      value: string | ReactElement;
      linkHref?: string;
      linkText?: string;
    }
  > = {
    username: {
      label: "Username",
      value: username,
    },
    password: {
      label: "Password",
      value: "************",
      linkHref: PATH_TO_CHANGE_PASSWORD,
      linkText: "Change Password",
    },
    email: {
      label: "Personal email",
      value: email,
      linkHref: PATH_TO_EDIT_PROFILE,
      linkText: "Change Email",
    },
    activeFactors: {
      label: factorsLabel,
      value: activeFactors ? (
        <ActiveFactors activeFactors={activeFactors} />
      ) : (
        "Active"
      ),
      linkHref: PATH_TO_MFA,
      linkText: "Update MFA",
    },
  };

  return (
    <>
      {FIELD_ORDER.map((fieldName, i) => {
        const addDivider = i !== FIELD_ORDER.length - 1;
        const { label, value, linkHref, linkText } = fieldMap[fieldName];

        return (
          <Fragment key={i}>
            <Label>
              <span className={styles.fieldName}>{label}</span>
            </Label>

            <div className={styles.fieldRow}>
              <div className={styles.fieldValue}>
                {!!value ? (
                  value
                ) : (
                  <div className={styles.spinnerContainer}>
                    <Spinner />
                  </div>
                )}
              </div>

              {showLinks && !!linkHref && (
                <Link
                  to={linkHref}
                  className={`milo--link-medium ${styles.linkHref}`}
                >
                  {linkText}
                </Link>
              )}
            </div>

            {addDivider && <hr className={styles.hr} />}
          </Fragment>
        );
      })}
    </>
  );
};

export default AccountSummary;
